import { getLocale } from "../../store/localeStore";

/**
 * =============================================================================
 * CABECERAS DE UNA LLAMADA A LA API DE REVI
 * =============================================================================
 * EL HUECO QUE CIERRA: el backend sabe responder en frances desde hace tiempo
 * —`localize()` mira la cabecera `Accept-Language` y devuelve el campo
 * traducido— pero NINGUNA llamada del portal la mandaba. Cero. Asi que el
 * contenido que vive en la base de datos (las categorias de terapia, los
 * textos de las escenas) llegaba siempre en castellano por muy en frances que
 * estuviera la interfaz.
 *
 * Se ve en los botones de filtro de las salas y en las etiquetas de color de
 * cada tarjeta: todo el portal en frances y esos rotulos en castellano.
 *
 * El idioma sale del mismo store que pinta la interfaz, asi que las dos cosas
 * no pueden desincronizarse.
 * =============================================================================
 */
/**
 * @param {string} [token]  el JWT, si la llamada lo necesita
 * @param {string} [idioma] idioma explicito. Si no se pasa, el del store
 *
 * PASAR EL IDIOMA EXPLICITAMENTE es mejor que dejar que se lea del store, y no
 * por gusto: entre que un componente decide recargar y el fetch sale de verdad
 * puede cambiar el idioma, y entonces se pediria con uno y se pintaria con
 * otro. Cuando quien llama ya sabe en que idioma lo quiere, que lo diga.
 */
export function cabecerasApi(token, idioma) {
  const cabeceras = { "Accept-Language": idioma || getLocale() };
  if (token) cabeceras.Authorization = `Bearer ${token}`;
  return cabeceras;
}
